import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';

const useSendJobsFeedback = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null)

    const sendJobsFeedback = async ({telephone, name, email, city } ) => {

        setLoading(true)
        setError(null)
        setResponse(null)

        try {
            const res = await postEmail('/feedback/jobs', { name, email, telephone, city });
            setResponse(res.data.message)

        } catch (err) {
            setError(getApiErrorMessage(err, 'Erro ao enviar feedback'));
        } finally {
            setLoading(false);
        }
    };
    return { sendJobsFeedback, response, loading, error };
}

export default useSendJobsFeedback
